<template>
  <div class="top-block">

    <ProgressBlock v-if="!noProgress"></ProgressBlock>
    <div class="dates">
      <template v-if="!noData">
        <span>Период с:</span>
        <div class="date">
          <date-picker v-model="date_from"

                       locale="ru"
                       :clearable="false"
                       format="dd.MM.yyyy"
                       model-type="yyyy-MM-dd"
                       auto-apply
                       :enable-time-picker="false"></date-picker>
        </div>
        <span>по:</span>
        <div class="date">
          <date-picker v-model="date_to"
                       locale="ru"
                       :clearable="false"
                       format="dd.MM.yyyy"
                       model-type="yyyy-MM-dd"
                       auto-apply
                       :enable-time-picker="false"></date-picker>
        </div>
      </template>
    </div>


  </div>
</template>
<script>


import ProgressBlock from "@/components/ProgressBlock.vue";

export default {
  name: 'TopBlock',
  components: {ProgressBlock},
  props: ["date_one", "date_two", "noData", "noProgress"],
  data() {
    return {}
  },
  computed: {
    date_from: {
      get() {
        return this.$store.getters.filterDateFrom
      },
      set(value) {
        this.$store.dispatch('setFilterDates', {from: value, to: false})
      }
    },
    date_to: {
      get() {
        return this.$store.getters.filterDateTo
      },
      set(value) {
        this.$store.dispatch('setFilterDates', {from: false, to: value})
      }
    },
  },

}
</script>

<style scoped lang="scss">
.top-block {
  display: flex;
  gap: 20px;
  margin-left: auto;

  .dates {
    width: 410px;
    display: flex;
    gap: 10px;
    align-items: baseline;

    .date {
      width: 150px;
    }
  }

  span {
    font-size: 12px;
  }
}

</style>

